import { useQuery } from "@tanstack/react-query";
import { getRunnerStats } from "../api";
import { calcPercentage } from "../horseRacing";

const useRunnerStats = (runnerName: string | undefined) => {
  const { data, isError, isLoading } = useQuery({
    queryKey: ["runner-stats", runnerName],
    queryFn: () => getRunnerStats({ runnerName: runnerName ?? "" }),
    enabled: !!runnerName,
  });

  const { numberRaces, numberRacesWon, numberRacesTop3 } =
    data?.HS_RunnerStats || {};

  const calcWinPercentage = calcPercentage(
    numberRaces ?? undefined,
    numberRacesWon ?? undefined
  );
  const calcTop3Percentage = calcPercentage(
    numberRaces ?? undefined,
    numberRacesTop3 ?? undefined
  );

  return {
    winPercentage: `${calcWinPercentage}%`,
    top3Percentage: `${calcTop3Percentage}%`,
    isError,
    isLoading,
  };
};

export default useRunnerStats;
